export const REPORT_SELECTION_LINE_PAINT = {
  "line-color": "blue",
  "line-width": 3,
};
